import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { useScreenToggles } from './useScreenToggles';
import { useEntityRef } from './useEntityRef';
import { useNewsData } from './useNewsData';
import { useAdminData } from './useAdminData';
import { useNewsletterQnA } from './useNewsletterQnA';

export function useAppState({ instance, accounts, apiRootUrl }) {

    // Stable date value used for default years/months
    const today = useMemo(() => new Date(), []);

    // Auth state and token helper
    const {
        activeAccount,
        handleLogin,
        getAccessToken,
    } = useAuth({ instance, accounts });

    // UI visibility state
    const screenState = useScreenToggles();

    // Entity selector data
    const {
        selectedEntities,
        setSelectedEntities,
        entityRef,
        entityRefLoading,
        handleChangeEntities,
    } = useEntityRef({
        activeAccount,
        apiRootUrl,
        getAccessToken,
    });

    // Newsletter article data
    const {
        data,
        error,
        selectedYear,
        selectedWeek,
        handleChangeWeek,
    } = useNewsData({
        activeAccount,
        apiRootUrl,
        getAccessToken,
        selectedEntities,
    });

    // Admin users and distribution data
    const adminState = useAdminData({
        activeAccount,
        apiRootUrl,
        getAccessToken,
    });

    // Newsletter Q&A state and submit handler
    const qnaState = useNewsletterQnA({
        activeAccount,
        apiRootUrl,
        getAccessToken,
        today,
    });

    // Return one combined object so App.js can stay mostly unchanged
    return {
        data,
        error,
        selectedYear,
        selectedWeek,
        selectedEntities,
        setSelectedEntities,
        entityRef,
        entityRefLoading,

        ...adminState,
        ...qnaState,
        ...screenState,

        activeAccount,
        handleLogin,
        handleChangeWeek,
        handleChangeEntities,

        currentYear: today.getFullYear(),
    };
}